import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import { Box, Typography } from '@mui/material';
import { AlSelectField } from './AlSelectField';

const numberFormat = (number) => {
    const intNumber = parseInt(number || '0', 10);
    return (intNumber < 10 ? '0' : '') + String(intNumber);
};

// Empty value (null / '') renders both selects as '--' so an untouched time is visible
// and fails the required check; picking one part fills the other with 00.
const EMPTY = '--';

const Time = ({ value, onChange, onBlur, error, required, hoursTooltip, minutesTooltip, label }) => {
    const [rawHours, rawMinutes] = (value || '').split(':');
    const hours = rawHours ? numberFormat(rawHours) : '';
    const minutes = rawMinutes ? numberFormat(rawMinutes) : '';

    const onHoursChange = (e) => {
        onChange(`${e.target.value}:${minutes || '00'}`);
    };

    const onMinutesChange = (e) => {
        onChange(`${hours || '00'}:${e.target.value}`);
    };

    const renderValue = (selected) => (selected === '' ? EMPTY : selected);

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',

                '& > *': {
                    flexBasis: 0,
                },

                '& > *:not(:first-of-type)': {
                    marginLeft: '10px',
                },
            }}
        >
            <AlSelectField
                value={hours}
                displayEmpty
                renderValue={renderValue}
                onChange={onHoursChange}
                onBlur={onBlur}
                alTooltip={hoursTooltip}
                error={error}
                required={required}
            >
                {[...Array(24)]
                    .map((_, key) => numberFormat(key))
                    .map((key) => (
                        <MenuItem value={key} key={key}>
                            {key}
                        </MenuItem>
                    ))}
            </AlSelectField>
            <AlSelectField
                value={minutes}
                displayEmpty
                renderValue={renderValue}
                onChange={onMinutesChange}
                onBlur={onBlur}
                alTooltip={minutesTooltip}
                alTooltipOut
                error={error}
                required={required}
            >
                {[...Array(60)]
                    .map((_, key) => numberFormat(key))
                    .map((key) => (
                        <MenuItem value={key} key={key}>
                            {key}
                        </MenuItem>
                    ))}
            </AlSelectField>
            <Typography variant="body2" sx={{ pt: 0.75, pl: 2, flexGrow: 1, color: 'text.secondary', lineHeight: 1.2 }}>
                {label}
            </Typography>
        </Box>
    );
};

export { Time };
